import emptyUnitsState from 'ducks/units/state'
import {
  setSelectedUnitRoutine,
  clearSelectedUnitRoutine,
  fetchBpUnitsRoutine,
  fetchUnitRoutine,
  fetchUnitInvitationsListRoutine,
  fetchUserUnitsRoutine,
  updateSelectedUnitRoutine,
  updateBpUnitInlineRoutine,
  fetchNoticeBoardRoutine,
  getFloorPlansForUnitRoutine,
  getUnitAccessRequestsRoutine,
  getUserRelationToUnitRoutine,
  fetchBpUnitsForAccessRequestRoutine,
  unitAccessApproveInvitationRoutine,
  unitAccessApproveRequestRoutine,
  unitAccessDenyRoutine,
  unitAccessFetchInvitationsRoutine,
  unitAccessFetchRequestsRoutine,
  unitAccessFetchRevokedRoutine,
  unitAccessFetchUnitRoutine
} from 'ducks/units/actions'
import { pathOr } from 'ramda'
import {
  clearSharedUnitsListForFileRoutine,
  getSharedUnitsListForFileRoutine
} from 'ducks/files/actions'

export default (state = emptyUnitsState, action) => {
  switch (action.type) {
    case setSelectedUnitRoutine.SUCCESS:
      return {
        ...state,
        editUnit: action.payload
      }
    case updateSelectedUnitRoutine.SUCCESS:
      return {
        ...state,
        selectedUnit: action.payload
      }
    case clearSelectedUnitRoutine.SUCCESS:
      return {
        ...state,
        selectedUnit: null,
        selectedUnitNotFound: false
      }
    case fetchUnitRoutine.REQUEST:
      return {
        ...state,
        selectedUnitNotFound: false
      }
    case fetchUnitRoutine.FAILURE:
      return {
        ...state,
        selectedUnit: null,
        selectedUnitNotFound: !!action.payload?.notFound
      }
    case fetchBpUnitsRoutine.SUCCESS:
      return {
        ...state,
        units: action.payload.items,
        bpUnitsTotal: action.payload.total,
        bpUnitsBpId: action.payload.bpId ?? null,
        loading: false,
        fetched: true
      }
    case fetchBpUnitsForAccessRequestRoutine.SUCCESS:
      return {
        ...state,
        units: action.payload,
        loading: false,
        fetched: true
      }
    case updateBpUnitInlineRoutine.SUCCESS: {
      const { unitId, unit, patch } = action.payload
      return {
        ...state,
        units: (state.units || []).map(item =>
          item?.id === unitId ? { ...item, ...(patch || {}), ...(unit || {}) } : item
        ),
        selectedUnit:
          state.selectedUnit?.id === unitId
            ? { ...state.selectedUnit, ...(patch || {}), ...(unit || {}) }
            : state.selectedUnit
      }
    }
    case fetchUnitRoutine.SUCCESS:
      return {
        ...state,
        selectedUnit: action.payload,
        selectedUnitNotFound: false
      }
    case fetchNoticeBoardRoutine.SUCCESS:
      return {
        ...state,
        notices: action.payload
      }
    case fetchUnitInvitationsListRoutine.SUCCESS:
      return {
        ...state,
        invitationsList: action.payload
      }
    case getSharedUnitsListForFileRoutine.SUCCESS:
      return {
        ...state,
        sharedUnitsList: action.payload
      }
    case clearSharedUnitsListForFileRoutine.SUCCESS:
      return {
        ...state,
        sharedUnitsList: []
      }
    case getFloorPlansForUnitRoutine.SUCCESS:
      return {
        ...state,
        floorplans: action.payload
      }
    case getUnitAccessRequestsRoutine.SUCCESS:
      return {
        ...state,
        accessRequests: action.payload
      }
    case getUserRelationToUnitRoutine.SUCCESS:
      return {
        ...state,
        userRelation: action.payload
      }
    case fetchUserUnitsRoutine.TRIGGER:
    case fetchUserUnitsRoutine.REQUEST:
    case fetchBpUnitsRoutine.TRIGGER:
    case fetchBpUnitsRoutine.REQUEST:
      return {
        ...state,
        units:
          action.type === fetchBpUnitsRoutine.TRIGGER ||
          action.type === fetchBpUnitsRoutine.REQUEST
            ? []
            : state.units,
        loading: true,
        fetched: false
      }

    case fetchUserUnitsRoutine.SUCCESS: {
      const payload = action.payload
      const incoming = Array.isArray(payload) ? payload : pathOr([], ['data'], payload)
      const currentPage = pathOr(1, ['meta', 'currentPage'], payload)
      const merged = currentPage > 1
        ? [...state.userUnits, ...incoming.filter(i => !state.userUnits.some(u => u.id === i.id))]
        : incoming
      return {
        ...state,
        userUnits: merged,
        totalPages: pathOr(1, ['meta', 'lastPage'], payload),
        totalFound: pathOr(0, ['meta', 'total'], payload),
        loading: false,
        fetched: true
      }
    }

    case fetchUserUnitsRoutine.FAILURE:
    case fetchBpUnitsRoutine.FAILURE:
      return {
        ...state,
        loading: false,
        fetched: true
      }

    case unitAccessFetchRequestsRoutine.REQUEST:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          requests: {
            loading: true,
            data: [],
            error: null
          }
        }
      }
    case unitAccessFetchRequestsRoutine.SUCCESS:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          requests: {
            loading: false,
            data: action.payload,
            error: null
          }
        }
      }
    case unitAccessFetchRequestsRoutine.FAILURE:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          requests: {
            loading: false,
            data: [],
            error: action.payload
          }
        }
      }

    case unitAccessFetchInvitationsRoutine.SUCCESS:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          invitations: {
            loading: false,
            data: action.payload,
            error: null
          }
        }
      }
    case unitAccessFetchRevokedRoutine.SUCCESS:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          revoked: {
            loading: false,
            data: action.payload,
            error: null
          }
        }
      }
    case unitAccessApproveInvitationRoutine.SUCCESS:
    case unitAccessDenyRoutine.SUCCESS:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          invitations: {
            ...state.unitAccess.invitations,
            data: (state.unitAccess.invitations.data || []).filter(
              inv => inv.id !== action.payload?.invitationId
            )
          }
        }
      }

    case unitAccessApproveRequestRoutine.SUCCESS:
      return {
        ...state,
        unitAccess: {
          ...state.unitAccess,
          requests: {
            ...state.unitAccess.requests,
            data: (state.unitAccess.requests.data || []).filter(
              req => req.id !== action.payload?.requestId
            )
          }
        }
      }


    case unitAccessFetchUnitRoutine.SUCCESS:
      return {
        ...state,
        currentUnit: {
          loading: false,
          error: null,
          data: action.payload
        }
      }

    case unitAccessFetchUnitRoutine.FAILURE:
      return {
        ...state,
        currentUnit: {
          loading: false,
          error: action.payload,
          data: null
        }
      }
    default:
      return state
  }
}
